import styled from 'styled-components'

export const PageContainer = styled.div`
  max-width: 1400px;
  box-sizing: border-box;
  margin: 0 auto;
  padding-bottom: 5px;
`

export const StakingContainer = styled.div`
  padding 0 20px;
  @media (max-width: 830px) {
    padding 0 12px;
  }
`

export const CardsContainer = styled.div`
  margin: 120px auto;
  width: 100%;
  display: grid;
  align-items:start;
  grid-template-columns: repeat(3, 1fr);
  gap 20px;
  @media (max-width: 1230px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 830px) {
    grid-template-columns: repeat(1, 1fr);
    margin: 50px auto;
  }
`

export const StakingText = styled.h3`
  font-size: 36px;
  color: #7a97df;
  width: max-content;
  margin: 200px auto;
  @media (max-width: 768px) {
    font-size: 24px;
    margin: 150px auto;
  }
`
